module.exports = __webpack_public_path__ + "static/img/5areaB_3.4701207.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_3.png
// module id = 1195
// module chunks = 1